import { Icon } from '@vrplatform/icons';
import {
  QuickSearchShortcutBadge,
  useQuickSearch,
} from '../components/spotlight';
import { NavbarRoute } from '../layout/navbar';

export const QuickSearchRoute = () => {
  const { open } = useQuickSearch();

  return (
    <NavbarRoute
      title="Search"
      link="/search"
      icon={<Icon icon="SearchIcon" size={18} />}
      notification={<QuickSearchShortcutBadge />}
      onClick={(event) => {
        event.preventDefault();
        open('navbar');
      }}
    />
  );
};
